import { render, staticRenderFns } from "./with-version-validator.vue?vue&type=template&id=52de3716&"
import script from "./with-version-validator.vue?vue&type=script&lang=ts&"
export * from "./with-version-validator.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports